import { SDF_COLORS } from '../sdfThemeConf';
export const sdfSentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${SDF_COLORS.success.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${SDF_COLORS.success.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${SDF_COLORS.success.main} !important`,
    },
};
//# sourceMappingURL=sdfSentryReportStyle.js.map